import React from 'react'

const contact = () => {
  return (
    <div><h1>this is contact page</h1></div>
  )
}

export default contact